import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import styles from 'assets/jss/material-dashboard-pro-react/views/errorPageStyle';
import useNewTheme from 'commons/hooks/newtheme/useNewTheme';
import PageNotFound from 'assets/img/404/page-not-found.png';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { getErrorPageLabels } from 'redux/modules/dynamicLabels/selectors';

// @ts-ignore
const useStyles = makeStyles(styles);

const ErrorPage = () => {
	const isNewDashBoardEnabled = useNewTheme();
	const classes = useStyles({ isNewDashBoardEnabled });
	const errorPageLabels = useSelector(getErrorPageLabels);
	return (
		<div className={classes.contentCenter}>
			<GridContainer>
				<GridItem md={12}>
					<img src={PageNotFound} alt="Error code" className={classes.image} />
					<div className={classes.error}>
						<p className={classes.errorTitle}>{errorPageLabels?.oops}</p>
						<p className={classes.errorDescription}>{errorPageLabels?.pageNotFound}</p>
						<Button
							className={classes.returnHome}
							variant="contained"
							color="primary"
							component={Link}
							to="/"
							aris-label={errorPageLabels?.returnHome}
						>
							{errorPageLabels?.returnHome}
						</Button>
					</div>
				</GridItem>
			</GridContainer>
		</div>
	);
};

export default ErrorPage;
